module.exports = __webpack_public_path__ + "img/zhxy_image_10.43cb42a9.png";